import styles from './incomingMainHeader.module.scss';
import {
  useDispatch,
  useSelector
} from "react-redux";
import { useTranslation } from "react-i18next";
import { useEffect } from "react";
import {
  AppDispatch,
  RootState
} from "../../../store";
import { Accordion } from "../../../shared/components/accordion/accordion";
import arrowIcon from "../../../shared/images/arrow.svg";
import { useGetTestCaseIncomingHistoryQuery } from "../../../api/testCaseIncomingRunHistoryService";
import {
  deleteSelectedTestCaseIncomingHistory,
  setSelectedTestCaseIncomingHistory
} from "../../../store/slices/testCaseIncomingSlice";
import { TestCaseIncomingHistory } from "../../../types/testCaseIncomingTypes";
import { MethodType } from "../../../shared/components/methodType/methodType";
import { ResultEnum } from "../../../types/clientTypes";
import { ReactComponent as CloseIcon } from "../../../shared/images/close.svg"
import { ReactComponent as SuccessIcon } from "../../../shared/images/success.svg"

export const IncomingMainHeader = () => {
  const dispatch = useDispatch<AppDispatch>()
  const { t } = useTranslation();

  const { selectedTestCaseIncoming, selectedTestCaseIncomingHistory } = useSelector((state: RootState) => state.testCaseIncomingSlice);

  const { data: testCaseIncomingHistories } = useGetTestCaseIncomingHistoryQuery(selectedTestCaseIncoming.id as number, { skip: !selectedTestCaseIncoming.id });

  useEffect(() => {
    setDefaultSelectedHistory();
  }, []);

  useEffect(() => {
    setDefaultSelectedHistory();
  }, [testCaseIncomingHistories]);

  const setDefaultSelectedHistory = (): void => {
    if (!!testCaseIncomingHistories?.length) {
      const history = testCaseIncomingHistories[0];
      if (!!history) {
        dispatch(setSelectedTestCaseIncomingHistory(history));
      } else {
        dispatch(deleteSelectedTestCaseIncomingHistory());
      }
    } else {
      dispatch(deleteSelectedTestCaseIncomingHistory());
    }
  }

  const onClickItem = (history: TestCaseIncomingHistory): void => {
    dispatch(setSelectedTestCaseIncomingHistory(history));
  }

  const getStatusMessage = (history: TestCaseIncomingHistory): string => {
    switch (history.status) {
      case ResultEnum.passed:
        return t("common.passed");
      case ResultEnum.failed:
        return t("common.failed");
      case ResultEnum.passedExecutionTime:
        return t("common.passedExecutionTime");
      case ResultEnum.serverError:
        return t("common.serverError");
      default:
        return "";
    }
  }

  const getStatusClass = (history: TestCaseIncomingHistory): string => {
    switch (history.status) {
      case ResultEnum.passed:
        return styles.passed;
      case ResultEnum.failed:
        return styles.failed;
      default:
        return "";
    }
  }

  const transformDate = (dateString: string): string => {
    const date = new Date(dateString);
    return `${date.getMonth() + 1}/${date.getDate()}/${date.getFullYear()} ${date.getHours()}:${date.getMinutes()}:${date.getSeconds()}`;
  }

  return (
    <div className={styles.container}>
      <Accordion activeClassName={styles.active}
                 maxHeight={400}
                 activeIndex={0}
                 disabledAutoScroll
                 data={
        [{
          title: (
            <div className={styles.accordionTitle}>
              <img src={arrowIcon} alt=""
                   className={styles.arrow}/>
              <div className={styles.methodType}>
                <MethodType methodId={selectedTestCaseIncoming.methodId} />
              </div>
              <span title={selectedTestCaseIncoming.name}>
                {selectedTestCaseIncoming.name}
              </span>
            </div>
          ),
          child: (
            <div className={styles.items}>
              {
                testCaseIncomingHistories?.map(((history, index) => (
                  <div className={`${styles.item} ${history.id === selectedTestCaseIncomingHistory.id ? styles.selected : ""}`}
                       key={index}
                       onClick={() => onClickItem(history)}>
                    <div className={styles.date}>
                      {transformDate(history.runDate)}
                    </div>
                    <div className={`${styles.status} ${getStatusClass(history)}`}>{getStatusMessage(history)}</div>
                    <div className={styles.testRail}>
                      {history.isExportedToTestRail ? (<SuccessIcon/>) : (<CloseIcon className={styles.error}/>)}
                      <span>{t("common.testRail")}</span>
                    </div>
                  </div>
                )))
              }
            </div>
          )
        }]
      }/>
      <div className={styles.urlBlock} title={selectedTestCaseIncoming.endpoint}>{selectedTestCaseIncoming.endpoint}</div>
    </div>
  )
}